// @flow

import { COMMON_HEADERS } from "./restApi";
import { buildHeadersForFetchConfig } from "./restApiRequestConfig.ts";
import buildURL from "axios/lib/helpers/buildURL";

import type { ApiClient, RequestHeaders } from "./restApi";

/** ApiClient that uses axios library underneath */
export class RestFetchApi implements ApiClient {
    headers = {
        Authorization: "",
        ...COMMON_HEADERS,
    };

    controllers = new Set < AbortController > ();

    post(url: string, body: any, headers?: RequestHeaders): Promise<any> {
        const controller = new AbortController();
        this.controllers.add(controller);
        const mergedHeaders: RequestHeaders = buildHeadersForFetchConfig(
            this.headers["Authorization"],
            headers
        );
        return new Promise((resolve, reject) => {
            fetch(buildURL(url), {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: mergedHeaders,
                redirect: "follow",
                referrerPolicy: "no-referrer",
                body: JSON.stringify(body),
                signal: controller.signal,
            })
                .then(response => {
                    this.controllers.delete(controller);
                    return response.json();
                })
                .then(data => resolve({ data }))
                .catch(error => {
                    this.controllers.delete(controller);
                    return reject(error);
                });
        });
    }

    get(path: string, params?: any, headers?: RequestHeaders) {
        throw Error("Not implemented");
    }

    put(path: string, body: any, headers?: RequestHeaders) {
        throw Error("Not implemented");
    }

    delete(path: string, params?: any, headers?: RequestHeaders) {
        throw Error("Not implemented");
    }

    setRequestHeader(key: string, val: string | null) {
        this.headers[key] = val;
    }

    abort(): void {
        for (const controller of this.controllers) {
            controller.abort();
        }
    }
}
